export const TIMING_DIV = '_';
export const SINGLE_GROUP_UUID = 'single';
